import './note-view-content.scss';

import React, { useEffect, useRef } from 'react';

import HighlightMarkdown from '../../services/highlight-markdown';

interface IProp {
  html: string;
}

export function NoteViewContent({ html }: IProp) {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.innerHTML = html;

      HighlightMarkdown.highlightAllUnder(divRef.current);
    }
  });

  return <article ref={divRef} className="note-view-content"></article>;
}
